interface Props {
  [key: string]: any
}
function LecturesIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 20" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M17.074 15C17.6044 15 18.1131 14.7893 18.4882 14.4142C18.8633 14.0391 19.074 13.5304 19.074 13V2C19.074 1.46957 18.8633 0.960859 18.4882 0.585786C18.1131 0.210714 17.6044 0 17.074 0H7.07397C7.07397 1 7.07397 0.3 7.07397 1H18V14H8.07397V15H17.074ZM12 5V6H5.07397V20H4.07397V14H2.07397V20H1V12H0L0.0739746 7C0.0739746 6.46957 0.124927 5.87507 0.5 5.5C0.875073 5.12493 1.04354 5 1.57397 5H12ZM5.07397 2C5.07397 2.53043 4.86326 3.03914 4.48819 3.41421C4.11312 3.78929 3.60441 4 3.07397 4C2.54354 4 2.03483 3.78929 1.65976 3.41421C1.28469 3.03914 1.07397 2.53043 1.07397 2C1.07397 1.46957 1.28469 0.960859 1.65976 0.585786C2.03483 0.210714 2.54354 0 3.07397 0C3.60441 0 4.11312 0.210714 4.48819 0.585786C4.86326 0.960859 5.07397 1.46957 5.07397 2Z"
        fill="none"
      />
    </svg>
  )
}

export default LecturesIcon
